const app = {
  ...window.app,

  animation: {
    lottie: {
      anims: {},
    
      init: function () {
        const _this = this;
        if (typeof lottie === 'undefined') return;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const animData = _this.anims[entry.target.id];
              if (!animData) return;
    
              const { anim, playOnHover } = animData;
              if (entry.intersectionRatio >= 0.7) {
                if (!playOnHover) {
                  anim.loop = true;
                  anim.play();
                }
              } else {
                anim.pause();
              }
            });
          },
          { threshold: [0.7] }
        );
    
        // Initialize animations
        window.bpLottie?.forEach((animation) => {
          const params = animation.params;
          if (!document.body.contains(params.container)) return;

          const anim = lottie.loadAnimation(params);
          _this.anims[params.container.id] = {
            anim: anim,
            playOnHover: params.playOnHover || false,
          };
    
          if (params.playOnHover) {
            const hoverElement = params.playOnHoverEl ? params.container.closest(params.playOnHoverEl) : params.container;
    
            hoverElement?.addEventListener('mouseenter', () => {
              anim.loop = true;
              anim.play();
            });
    
            hoverElement?.addEventListener('mouseleave', () => {
              anim.loop = false;
            });
          } else {
            observer.observe(params.container);
          }
        });
      },
    },  

    typing: {
      els: document.querySelectorAll('.mt-anim-typing'),
      config: {
        typingSpeed: 100,
        waitTime: 1500
      },

      init: function() {
        const _this = this;
        if (_this.els.length == 0) return;

        _this.els.forEach(container => {
          const sentences = container.getAttribute('data-text').split(';').map(sentence => sentence.trim());
          let currentSentenceIndex = 0;
          let isTyping = false;

          const typeNextLetter = () => {
            const currentSentence = sentences[currentSentenceIndex];
            const currentSentenceLength = currentSentence.length;
            let currentLetterIndex = container.textContent.length;

            if (isTyping) {
              if (currentLetterIndex < currentSentenceLength) {
                container.textContent = currentSentence.slice(0, currentLetterIndex + 1);
                currentLetterIndex++;
                setTimeout(typeNextLetter, _this.config.typingSpeed);
              } else {
                isTyping = false;
                setTimeout(eraseSentence, _this.config.waitTime);
              }
            } else {
              if (currentLetterIndex > 0) {
                container.textContent = container.textContent.slice(0, currentLetterIndex - 1);
                currentLetterIndex--;
                setTimeout(typeNextLetter, _this.config.typingSpeed);
              } else {
                isTyping = true;
                currentSentenceIndex = (currentSentenceIndex + 1) % sentences.length;
                currentLetterIndex = 0;
                setTimeout(typeNextLetter, _this.config.typingSpeed);
              }
            }
          };

          const eraseSentence = () => {
            setTimeout(() => {
              isTyping = false;
              typeNextLetter();
            }, _this.config.waitTime);
          };

          typeNextLetter();
        });
      }
    },

    rotatingText: {
      els: document.querySelectorAll('.mt-anim-rotating-text'),

      init: function() {
        const _this = this;
        if (_this.els.length == 0) return;

        _this.els.forEach(container => {
          const swiper = new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 0,
            direction: 'vertical',
            speed: 600,
            allowTouchMove: false,
            autoplay: {
              delay: 600,
            },
            loop: true
          });
        });
      }
    },

    init: function() {
      const _this = this;
      _this.typing.init();
      _this.rotatingText.init();
      _this.lottie.init();
    }
  },

  form: {
    quantity: function () {
      window.addEventListener('click', e => {
        const button = e.target.closest('.mt-quantity__button, [data-cart-qty-button]');
        if (button) {
          const input = button.parentElement.querySelector('.mt-quantity__input, [data-cart-qty-input]');
          let quantity = Number(input.value);

          if (button.dataset.action === 'decrease') {
            input.value = (quantity - 1 >= 0) ? quantity - 1 : 0;
          } else {
            const inputMax = input.max || 20;
            input.value = (quantity + 1 <= inputMax) ? quantity + 1 : 20;
          }

          input.dispatchEvent(new Event('change'));
        }
      });
    },

    init: function () {
      this.quantity();
    }
  },

  prefetch: {
    init: function() {
      const supportedLinks = ['/products/', '/pages/soccer', '/pages/basketball', '/pages/tennis', '/pages/martial-arts', '/pages/physiotherapy', '/pages/fitness', '/pages/reactive-intelligence', '/pages/experience', '/collections/shop-page', '/pages/athlete', '/pages/coach', '/pages/young-athletes', '/pages/physical-therapist', '/pages/fitness-athlete'];
      supportedLinks.forEach(linkPart => {
        const links = document.querySelectorAll(`a[href*="${linkPart}"]`);
        links.forEach(link => {
          const prefetchResource = () => {
            const prefetchLink = document.createElement('link');
            prefetchLink.rel = 'prefetch';
            prefetchLink.href = link.href;
            prefetchLink.fetchPriority = 'high';
            prefetchLink.as = 'document';
            document.head.appendChild(prefetchLink);
          };
          link.addEventListener('mouseenter', prefetchResource, { once: true });
          link.addEventListener('touchstart', prefetchResource, { once: true });
        });
      });
    }
  },

  productForm: {
    forms: document.querySelectorAll('.mt-product-form:not([data-events="true"])'),
    cartUrl: window.Shopify.routes.root + 'cart',

    // Resolve post-add behavior ('mini-cart' | 'redirect') for the current breakpoint.
    // Defaults: desktop (>768px) → mini-cart, mobile → redirect. Overridable via
    // window.theme.atc.{desktopBehavior,mobileBehavior} (set in theme.liquid, e.g. for A/B tests).
    // Falls back to redirect when the resolved behavior is 'mini-cart' but no mini-cart element exists.
    resolveBehavior: function (miniCart) {
      const cfg = (window.theme && window.theme.atc) || {};
      const isDesktop = window.innerWidth > 768;
      const fallback = isDesktop ? 'mini-cart' : 'redirect';
      const configured = isDesktop ? cfg.desktopBehavior : cfg.mobileBehavior;
      const behavior = configured || fallback;
      return (behavior === 'mini-cart' && !miniCart) ? 'redirect' : behavior;
    },

    init: function () {
      const _this = this;
      _this.forms = document.querySelectorAll('.mt-product-form:not([data-events="true"])');

      if (_this.forms.length === 0) return;

      _this.forms.forEach(form => {
        const miniCart = document.querySelector('.mt-mini-cart');
        const productPage = form.closest('.mt-product');
        const fields = {
          id: form.querySelector('[name="id"]'),
          quantity: form.querySelector('[name="quantity"]'),
          sellingPlan: form.querySelector('[name="selling_plan"]'),
          button: form.querySelector('button[type="submit"]')
        };
        const isUnique = (form.dataset.unique == 'true');
        let stickyProductForm = null;
        let additionalOffer = null;

        // PDP additional offer
        if (productPage !== null) {
          additionalOffer = {
            section: productPage.querySelectorAll('.mt-form-offer:not([data-events="true"])'),
            checkbox: productPage.querySelectorAll('.mt-form-offer__checkbox input'),
            button: productPage.querySelectorAll('.mt-form-offer__btn')
          };
          stickyProductForm = productPage.querySelector('.mt-sticky-product-form .mt-btn');
          if (additionalOffer.section && additionalOffer.checkbox.length > 0) {
            additionalOffer.checkbox.forEach(offerCheckbox => {
              const offer = offerCheckbox.closest('.mt-form-offer');
              offerCheckbox.addEventListener('change', e => {
                e.preventDefault();
                offer.dataset.offerActive = offerCheckbox.checked;
                window.app.productPage.updatePrice();
              });
            });
            additionalOffer.button.forEach(offerButton => {
              const offerCheckbox = offerButton.closest('.mt-form-offer').querySelector('.mt-form-offer__checkbox input');
              if (!offerCheckbox) return;
              offerButton.addEventListener('click', e => {
                e.preventDefault();
                offerCheckbox.checked = !offerCheckbox.checked;
                offerCheckbox.dispatchEvent(new Event('change'));
              })
            });
            additionalOffer.section.forEach(section => (section.dataset.events = 'true'));
          }
        }

        // Main ATC form
        form.addEventListener('submit', e => {
          e.preventDefault();
          e.stopPropagation();

          const nestedChildren = [];
          const standaloneItems = [];
          const formData = { items: [] };
          const bundleId = app.utilities.generateShortId();
          const bundleIdQ = app.utilities.generateShortId();
          let isBundle = false;

          if (fields.id === undefined) return;

          // LP Flow
          if (form.classList.contains('mt-lp-form')) {
            fields.id = form.querySelector('[name="id"]:checked');

            const optionGroups = form.querySelectorAll('.mt-product-option__list');
            if (optionGroups.length > 0) {
              let isValid = true;
              optionGroups.forEach(optionGroup => {
                const error = optionGroup.querySelector('.mt-product-option__error');
                const options = optionGroup.querySelectorAll('.mt-product-option__item input');
                const selectedOption = [...options].find(o => o.checked);
                if (!selectedOption && error) {
                  isValid = false;
                  error.classList.add('visible');
                  error.setAttribute('aria-hidden', false);
                  options.forEach(option => {
                    option.addEventListener('change', () => {
                      error.classList.remove('visible');
                      error.setAttribute('aria-hidden', true);
                    }, { once: true });
                  })
                }
              });
              if (!isValid) {
                form.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
                return;
              }
            }
          }

          // Disable ATC button
          app.utilities.toggleButtonLoading(fields.button, true);

          // Additional required items — HYBRID: keep legacy _bundleId grouping (so the theme's
          // cart integrity logic — NFS removal, bundle verify, rendering — keeps protecting the
          // line) AND stamp parent_id so Shopify also records a native nested cart line.
          // parent_id references the main product's VARIANT id and must resolve within the same
          // /cart/add.js request, so these children are appended AFTER the parent line below.
          const productGroupArr = app.utilities.getCartConnectionsFor(fields.id.dataset.productId);
          if (productGroupArr.length > 0) {
            productGroupArr.forEach(productGroup => {
              const childProperties = {
                _bundleId: `#${bundleId}`,
                _bundleIdQ: `#${bundleIdQ}`,
                _sellingPlan: productGroup.product_selling_plan,
                _itemEditable: false,
                _itemRemovable: false
              };
              // Note from the Bundles Configurator, rendered under the line's short description in the cart
              if (productGroup.note) childProperties._bundleNote = productGroup.note;
              nestedChildren.push({
                id: productGroup.product_variant_id,
                quantity: Number(fields.quantity.value),
                selling_plan: productGroup.product_selling_plan,
                parent_id: Number(fields.id.value),
                properties: childProperties
              });
            });
            isBundle = true;
          }

          // Additional PDP offer — also linked to the main product via native nested cart lines
          // (parent_id = main variant id). Appended after the parent line below. Hybrid: legacy
          // properties are kept so the theme's cart integrity/rendering keeps working.
          if (additionalOffer !== null && additionalOffer.checkbox.length > 0) {
            additionalOffer.checkbox.forEach(offerCheckbox => {
              if (!offerCheckbox.checked) return;
              const offerQuantity = Number(offerCheckbox.dataset.quantity) || 1;
              if (offerCheckbox.dataset.standalone === 'true') {
                standaloneItems.push({
                  id: Number(offerCheckbox.dataset.variant),
                  quantity: 1,
                  selling_plan: offerCheckbox.dataset.sellingPlan ? Number(offerCheckbox.dataset.sellingPlan) : null,
                  properties: {
                    _uId: `#${app.utilities.generateShortId()}`,
                    _sellingPlan: offerCheckbox.dataset.sellingPlan ? Number(offerCheckbox.dataset.sellingPlan) : null,
                    _itemEditable: false,
                    _upsell: 'pdp_addon'
                  }
                });
              } else if (offerCheckbox.dataset.upsell === 'true') {
                nestedChildren.push({
                  id: Number(offerCheckbox.dataset.variant),
                  quantity: offerQuantity,
                  selling_plan: offerCheckbox.dataset.sellingPlan ? Number(offerCheckbox.dataset.sellingPlan) : null,
                  parent_id: Number(fields.id.value),
                  properties: {
                    _sellingPlan: offerCheckbox.dataset.sellingPlan ? Number(offerCheckbox.dataset.sellingPlan) : null,
                    _itemEditable: true,
                    _itemRemovable: offerCheckbox.dataset.removable,
                    _upsell: 'pdp_addon'
                  }
                });
              } else {
                nestedChildren.push({
                  id: Number(offerCheckbox.dataset.variant),
                  quantity: offerQuantity,
                  selling_plan: offerCheckbox.dataset.sellingPlan ? Number(offerCheckbox.dataset.sellingPlan) : null,
                  parent_id: Number(fields.id.value),
                  properties: {
                    _bundleId: `#${bundleId}`,
                    _bundleIdQ: `#${bundleIdQ}`,
                    _sellingPlan: offerCheckbox.dataset.sellingPlan ? Number(offerCheckbox.dataset.sellingPlan) : null,
                    _itemEditable: false,
                    _itemRemovable: offerCheckbox.dataset.removable,
                    _upsell: 'pdp_addon'
                  }
                });
                isBundle = true;
              }
            });
          }

          // Prepare formData
          let productData = {
            id: Number(fields.id.value),
            quantity: Number(fields.quantity.value),
            selling_plan: fields.sellingPlan?.value ? Number(fields.sellingPlan.value) : null,
            properties: {}
          };
          isBundle && (productData.properties = {
            ...productData.properties,
            _bundleId: `#${bundleId}`,
            _itemType: 'product-main'
          });
          isUnique && (productData.properties = {
            ...productData.properties,
            _uId: `#${app.utilities.generateShortId()}`,
            _itemEditable: false
          });
          standaloneItems.forEach(item => formData.items.push(item));
          formData.items.push(productData);
          // Nested children (cartConnections + PDP offers) go after the parent so parent_id resolves in-request
          (nestedChildren.length > 0) && nestedChildren.forEach(child => formData.items.push(child));

          // Prepare DataLayer products
          const productsToAdd = [fields.id.dataset.product];
          additionalOffer?.checkbox.forEach(offerCheckbox => {
            if (!offerCheckbox.checked) return;
            try {
              const offerProduct = JSON.parse(offerCheckbox.dataset.product);
              offerProduct.quantity = Number(offerCheckbox.dataset.quantity) || 1;
              productsToAdd.push(JSON.stringify(offerProduct));
            } catch (e) {
              productsToAdd.push(offerCheckbox.dataset.product);
            }
          });

          // Add to cart — behavior (mini-cart vs redirect) resolved per breakpoint, overridable via window.theme.atc
          const behavior = _this.resolveBehavior(miniCart);

          // Show mini-cart after adding
          const addViaMiniCart = () => {
            formData.sections = 'mt-mini-cart';
            app.cart.updateView(formData, 'add', () => {
              if (form.getAttribute('data-force-cart')) {
                window.top.location = _this.cartUrl;
                return;
              }
              if (form.getAttribute('data-force-checkout')) {
                window.top.location = '/checkout';
                return;
              }
              miniCart.classList.add('active');
              miniCart.setAttribute('aria-hidden', false);
              setTimeout(() => miniCart.classList.add('visible'), 50);
              app.utilities.toggleButtonLoading(fields.button, false);
              app.dl.addedToCart(...productsToAdd);
            });
          };

          // Add via fetch, then redirect (to checkout when forced, otherwise to cart)
          const addViaRedirect = () => {
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(formData)
            })
              .then(response => response.json())
              .then(() => {
                if (form.getAttribute('data-force-checkout')) {
                  window.top.location = '/checkout';
                  return;
                }
                app.utilities.toggleButtonLoading(fields.button, false);
                app.dl.addedToCart(...productsToAdd);
                window.top.location = _this.cartUrl;
              })
              .catch((error) => {
                console.error('Error:', error);
                app.utilities.toggleButtonLoading(fields.button, false);
                window.top.location.reload();
              });
          };

          const addOnCartPage = () => {
            formData.sections = 'cart-page';
            app.cart.updateView(formData, 'add', () => {
              app.dl.addedToCart(...productsToAdd);
            });
          };

          const runAdd = () => {
            const onCartPage = app.cart.cartType === 'page' && !form.getAttribute('data-force-checkout');
            const add = onCartPage ? addOnCartPage : (behavior === 'mini-cart') ? addViaMiniCart : addViaRedirect;
            if (form.dataset.cartClear == 'true') {
              app.cart.clear(() => add());
            } else {
              add();
            }
          };

          // Apply membership discount first when applicable, then add
          app.discounts.withMembership(formData.items, runAdd);
        });

        fields.button && (fields.button.disabled = false);
        stickyProductForm && (stickyProductForm.disabled = false);

        form.dataset.events = true;
      });
    }
  },

  productItem: {
    els: document.querySelectorAll('.mt-product-item:not([data-events="true"]), .cart-product-card:not([data-events="true"])'),

    init: function() {
      const _this = this;
      _this.els = document.querySelectorAll('.mt-product-item:not([data-events="true"]), .cart-product-card:not([data-events="true"])');

      if (_this.els.length === 0) return;
      const collectionName = document.querySelector('.mt-collection-header')?.dataset.collection || '';
      _this.els.forEach(item => {
        const sectionName = item.closest('section, .section')?.querySelector('.mt-featured-collection__heading, .mt-collection__heading, .featured-collection__heading');
        const listName = item.closest('[data-list-name]')?.dataset.listName || (sectionName ? sectionName.innerText : '');
        const itemTitle = item.querySelector('.mt-product-item__title, .cart-product-card__title');
        const itemLinks = item.querySelectorAll('.mt-product-item__image-wrapper, .mt-product-item__title');
        const itemDetails = item.querySelector('.mt-product-form input[name="id"]') || item.querySelector('.mt-product-form a[data-product]');
        const itemLinkCTA = item.querySelector('.mt-product-form a.mt-btn');
        const isCourse = item.dataset.course === 'true';

        itemLinks.forEach(link => {
          link.addEventListener('click', () => {
            if (isCourse) {
              window.app.dl.ctaClick(itemTitle.innerText, { location: listName, ...(collectionName && { collection_name: collectionName }) });
            } else if (itemDetails) {
              window.app.dl.selectItem(itemDetails.dataset.product, listName);
            }
          });
        });

        itemLinkCTA?.addEventListener('click', () => {
          window.app.dl.ctaClick(itemTitle.innerText, { location: listName, ...(collectionName && { collection_name: collectionName }) });
        });

        item.dataset.events = true;
      });
    }
  },

  cart: {
    el: {
      cartForm: document.querySelector('#mt-cart-form'),
      cartIcon: document.querySelector('.header__cart'),
      cartPageContent: document.querySelector('.cart__grid'),
      cartPageHeader: document.querySelector('.cart__header'),
      miniCart: document.querySelector('.mt-mini-cart'),
      miniCartClose: document.querySelector('.mt-mini-cart__close'),
      itemsList: document.querySelector('.mt-cart, [data-cart-items]'),
      items: document.querySelectorAll('.mt-cart__item, [data-cart-item]'),
      summary: document.querySelector('.mt-mini-cart__summary, .cart__summary'),
      summaryButton: document.querySelector('.mt-mini-cart__summary-button--checkout, .cart-summary__checkout'),
      empty: document.querySelector('.mt-mini-cart__empty, .cart__empty'),
      limitNotice: document.querySelector('.mt-cart-notice')
    },
    bundlesAs: 'separate',
    bundles: {},
    bundlesAdjust: (window.sessionStorage.getItem('mt-cart-adjustment') !== null) ? JSON.parse(window.sessionStorage.getItem('mt-cart-adjustment')) : {},
    notForSale: { variants: [], keysToRemove: [] },
    cartLimit: 20,
    cartType: null,

    debounce: function (func, timeout = 300) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
      };
    },

    clear: function (cb = null) {
      fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(r => r.json())
        .then(r => (r.item_count === 0 && typeof cb === 'function') && cb());
    },

    updateView: function (data = null, type = 'update', cb = null) {
      if (data === null) return;

      const _this = this;
      const cartUrl = {
        add: 'cart/add.js',
        update: 'cart/update.json'
      };
      _this.el.itemsList.classList.add('mt-cart--loading');
      _this.el.summaryButton && (_this.el.summaryButton.disabled = true);

      // Sync adjustment
      window.sessionStorage.setItem('mt-cart-adjustment', JSON.stringify(_this.bundlesAdjust));

      // Update section ID on cart page
      let sectionId = data.sections;
      if (sectionId === 'cart-page') {
        sectionId = document.querySelector('.cart').dataset.section;
        data.sections = sectionId;
      }

      const isPage = _this.cartType === 'page';
      const cartHeader = isPage ? document.querySelector('.cart-header[data-section]') : null;
      const cartHeaderId = cartHeader && cartHeader.dataset.section;
      if (cartHeaderId) data.sections = data.sections ? data.sections + ',' + cartHeaderId : cartHeaderId;
      if (isPage) data.sections_url = window.location.pathname + window.location.search;

      fetch(window.Shopify.routes.root + cartUrl[type], {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(response => {
          if (_this.cartType === 'page') {
            _this.renderPageCart(response.sections[sectionId]);
          } else if (_this.cartType === 'mini') {
            _this.renderMiniCart(response.sections['mt-mini-cart']);
          }

          if (cartHeaderId) {
            const headerHtml = response.sections && response.sections[cartHeaderId];
            headerHtml ? _this.renderCartHeader(headerHtml) : _this.fetchCartHeader(cartHeaderId);
          }

          // Fire custom event
          const updateEvent = new CustomEvent('mt-cart-update', {});
          document.dispatchEvent(updateEvent);

          (cb !== null) && cb();
          _this.init();
        })
        .catch((error) => {
          console.error('Error:', error);
          window.top.location.reload();
        });
    },

    fetchCartHeader: function (sectionId) {
      const _this = this;
      const url = new URL(window.location.href);
      url.searchParams.set('sections', sectionId);
      fetch(url.toString())
        .then(response => (response.ok ? response.json() : null))
        .then(sections => {
          if (sections && sections[sectionId]) _this.renderCartHeader(sections[sectionId], false);
        })
        .catch(() => {});
    },

    renderCartHeader: function (html, refetch = true) {
      const view = document.createElement('div');
      view.innerHTML = html;
      const fresh = view.querySelector('.cart-header');
      const current = document.querySelector('.cart-header');
      if (!current) return;
      if (fresh) {
        current.replaceWith(fresh);
      } else if (refetch) {
        this.fetchCartHeader(current.dataset.section);
      }
    },

    // Re-render the full cart page from an updated section HTML
    renderPageCart: function (html) {
      const _this = this;
      const view = document.createElement('div');
      view.innerHTML = html;

      const nextGrid = view.querySelector('.cart__grid');
      const grid = document.querySelector('.cart__grid');
      if (!nextGrid || !grid) return;

      const active = document.activeElement;
      const activeLine = active && active.closest ? active.closest('[data-cart-item]') : null;
      const focusTarget = activeLine && {
        key: activeLine.dataset.key,
        control: active.dataset.action || (active.hasAttribute('data-cart-qty-input') ? 'quantity' : null)
      };

      grid.innerHTML = nextGrid.innerHTML;

      if (focusTarget && focusTarget.control) {
        const esc = (v) => (window.CSS && CSS.escape ? CSS.escape(v) : v);
        const line = grid.querySelector('[data-cart-item][data-key="' + esc(focusTarget.key) + '"]');
        const selector = focusTarget.control === 'quantity'
          ? '[data-cart-qty-input]'
          : '[data-action="' + focusTarget.control + '"]';
        const control = line && line.querySelector(selector);
        if (control && !control.disabled) control.focus();
      }

      const status = document.querySelector('[data-cart-status]');
      if (status) status.textContent = window.languages?.cartUpdated || 'Cart updated';

      _this.el.cartForm = document.querySelector('#mt-cart-form');
      _this.el.cartPageContent = grid;
      _this.el.cartPageHeader = grid.querySelector('.cart__header');
      _this.el.itemsList = grid.querySelector('[data-cart-items]');
      _this.el.items = grid.querySelectorAll('[data-cart-item]');
      _this.el.summary = grid.querySelector('.cart__summary');
      _this.el.summaryButton = grid.querySelector('.cart-summary__checkout');
      _this.el.empty = grid.querySelector('.cart__empty');

      _this.el.itemsList && _this.el.itemsList.classList.remove('mt-cart--loading');
      _this.el.summaryButton && (_this.el.summaryButton.disabled = false);
      _this.el.cartIcon && _this.el.itemsList && _this.el.cartIcon.setAttribute('data-items', _this.el.itemsList.dataset.items);

      window.Shopify?.PaymentButton?.init?.();

      if (typeof affirm === 'object') affirm?.ui?.refresh?.();
    },

    // Re-render the mini cart from an updated section HTML
    renderMiniCart: function (html) {
      const _this = this;
      const view = document.createElement('div');
      view.innerHTML = html;

      const sections = {
        miniCart: view.querySelector('.mt-mini-cart'),
        itemsList: view.querySelector('.mt-cart'),
        items: view.querySelectorAll('.mt-cart__item'),
        summary: view.querySelector('.mt-mini-cart__summary'),
        empty: view.querySelector('.mt-mini-cart__empty'),
        limitNotice: view.querySelector('.mt-cart-notice')
      };

      _this.el.itemsList.innerHTML = sections.itemsList.innerHTML;
      _this.el.summary.innerHTML = sections.summary.innerHTML;
      _this.el.empty.outerHTML = sections.empty.outerHTML;

      _this.el.miniCart.setAttribute('data-items', sections.miniCart.dataset.items);
      _this.el.miniCart.setAttribute('data-item-lines', sections.miniCart.dataset.itemLines);

      _this.el.itemsList = document.querySelector('.mt-cart');
      _this.el.items = document.querySelectorAll('.mt-cart__item');
      _this.el.summary = document.querySelector('.mt-mini-cart__summary');
      _this.el.summaryButton = document.querySelector('.mt-mini-cart__summary-button--checkout');
      _this.el.empty = document.querySelector('.mt-mini-cart__empty');

      _this.el.itemsList && _this.el.itemsList.classList.remove('mt-cart--loading');
      _this.el.summaryButton && (_this.el.summaryButton.disabled = false);

      _this.el.cartIcon && _this.el.cartIcon.setAttribute('data-items', sections.miniCart.dataset.items);
    },

    verifyBundles: function () {
      const _this = this;

      if (Object.keys(_this.bundles).length > 0) {
        const bundlesUpdate = { updates: {} };
        bundlesUpdate.sections = (_this.cartType === 'page') ? 'cart-page' : 'mt-mini-cart';

        Object.keys(_this.bundles).forEach(key => {
          const bundle = _this.bundles[key];
          const bundleMemberships = bundle.products.filter(product => (product.type === 'membership'));
          let filteredProducts = [];

          // Remove broken bundles
          if (bundle.products.length === 1 && !_this.bundlesAdjust[bundle.products[0].id]) {
            bundlesUpdate.updates[bundle.products[0].key] = 0;
          }

          if (_this.bundlesAs === 'separate') {
            filteredProducts = bundle.products.filter(product => (product.quantity !== bundle.quantity && product.type !== 'membership'));

            // Separate memberships logic
            const filteredMemberships = bundle.products.filter(product => product.type === 'membership');
            let membershipsQuantity = 0;
            filteredMemberships.forEach(membership => (membershipsQuantity += membership.quantity));

            if (filteredMemberships.length > 0 && filteredMemberships.length !== bundle.quantity) {
              if (bundle.quantity > filteredMemberships.length) {
                const membership = filteredMemberships[0];
                const bundlesToAddData = { items: [] };
                bundlesToAddData.sections = (_this.cartType === 'page') ? 'cart-page' : 'mt-mini-cart';
                let diff = bundle.quantity - filteredMemberships.length;
                (_this.bundlesAdjust[membership.id]) && (diff -= _this.bundlesAdjust[membership.id]);

                if (diff > 0) {
                  for (let i = 0; i < diff; i++) {
                    const bundleIdQ = app.utilities.generateShortId();
                    const sellingPlan = membership.sellingPlan ? Number(membership.sellingPlan) : null;
                    bundlesToAddData.items.push({
                      id: Number(membership.variantId),
                      quantity: 1,
                      selling_plan: sellingPlan,
                      properties: {
                        _bundleId: membership.id,
                        _bundleIdQ: `${membership.id}:${bundleIdQ}`,
                        _sellingPlan: sellingPlan,
                        _itemEditable: (membership.editable === "true"),
                        _itemRemovable: (membership.removable === "true")
                      }
                    });
                  }
                  _this.updateView(bundlesToAddData, 'add');
                }
              }
              if (bundle.quantity < filteredMemberships.length) {
                const diff = filteredMemberships.length - bundle.quantity;
                for (let i = 0; i < diff; i++) {
                  const membership = filteredMemberships.shift();
                  bundlesUpdate.updates[membership.key] = 0;

                  (_this.bundlesAdjust[membership.id]) && (_this.bundlesAdjust[membership.id] = 0);
                }
              }
            } else if (filteredMemberships.length > 0 && membershipsQuantity != bundle.quantity) {
              filteredMemberships.forEach(membership => (bundlesUpdate.updates[membership.key] = 1));
            }
          } else {
            if (bundleMemberships.length === 1) {
              filteredProducts = bundle.products.filter(product => (product.quantity !== bundle.quantity));
            } else {
              bundleMemberships.shift();
              bundleMemberships.forEach(membership => (bundlesUpdate.updates[membership.key] = 0));
            }
          }

          // Get products with different quantities 
          if (filteredProducts.length > 0) {
            filteredProducts.forEach(product => (bundlesUpdate.updates[product.key] = bundle.quantity));
          }
        });

        // Update view if required
        if (Object.keys(bundlesUpdate.updates).length > 0) {
          _this.updateView(bundlesUpdate, 'update');
        }
      }
    },

    getAllBundles: function () {
      const _this = this;

      _this.bundles = {};

      _this.el.items.forEach(item => {
        const itemData = {
          bundleId: item.dataset.bundleId,
          bundleIdQ: item.dataset.bundleIdq,
          key: item.dataset.key,
          type: item.dataset.type,
          variantId: item.dataset.variant,
          productId: item.dataset.product,
          sellingPlan: item.dataset.sellingPlan,
          quantity: Number(item.dataset.quantity),
          editable: item.dataset.editable,
          removable: item.dataset.removable
        };
        const itemConnection = app.utilities.getCartConnectionsFor(itemData.productId);

        if (itemData.bundleId) {
          if (_this.bundles[itemData.bundleId]) {
            (itemData.type === 'product-main' && !_this.bundles[itemData.bundleId].quantity) && (_this.bundles[itemData.bundleId].quantity = itemData.quantity);
            _this.bundles[itemData.bundleId].products.push({
              key: itemData.key,
              variantId: itemData.variantId,
              productId: itemData.productId,
              sellingPlan: itemData.sellingPlan ? itemData.sellingPlan : null,
              id: itemData.bundleId,
              idQ: itemData.bundleIdQ ? itemData.bundleIdQ : null,
              quantity: itemData.quantity,
              type: itemData.type,
              editable: itemData.editable,
              removable: itemData.removable
            });
          } else {
            _this.bundles[itemData.bundleId] = {
              quantity: (itemData.type === 'product-main') ? itemData.quantity : 0,
              products: [
                {
                  key: itemData.key,
                  variantId: itemData.variantId,
                  productId: itemData.productId,
                  sellingPlan: itemData.sellingPlan ? itemData.sellingPlan : null,
                  id: itemData.bundleId,
                  idQ: itemData.bundleIdQ ? itemData.bundleIdQ : null,
                  quantity: itemData.quantity,
                  type: itemData.type,
                  editable: itemData.editable,
                  removable: itemData.removable
                }
              ]
            };
          }
        } else if (itemConnection.length > 0) {
          // Remove the damaged bundles
          const tempBundleId = app.utilities.generateShortId();
          _this.bundles[tempBundleId] = {
            quantity: (itemData.type === 'product-main') ? itemData.quantity : 0,
            products: [
              {
                key: itemData.key,
                variantId: itemData.variantId,
                productId: itemData.productId,
                sellingPlan: null,
                id: tempBundleId,
                idQ: null,
                quantity: itemData.quantity,
                type: 'product',
                editable: false,
                removable: false
              }
            ]
          };
        }
      });

      (Object.keys(_this.bundles).length > 0) && _this.verifyBundles();
    },

    // Add a warranty variant as a nested cart line under an existing parent line. Quantity matches
    // the parent; parent_line_key + _warrantyFor tie them together (native removal cascade + qty sync).
    // replaceKey: line key of a warranty already nested under this parent — removed first so
    // switching plans swaps the line instead of stacking a second one.
    addWarranty: function (variantId, parentKey, cb, productJson = null, replaceKey = null) {
      const _this = this;
      if (!variantId || !parentKey) return;
      const esc = (v) => (window.CSS && CSS.escape ? CSS.escape(v) : v);
      const parent = document.querySelector('.mt-cart__item[data-key="' + esc(parentKey) + '"]');
      const parentQty = parent ? Number(parent.dataset.quantity) || 1 : 1;
      const data = {
        items: [{
          id: Number(variantId),
          quantity: parentQty,
          parent_line_key: parentKey,
          properties: { _warrantyFor: parentKey }
        }],
        sections: (_this.cartType === 'page') ? 'cart-page' : 'mt-mini-cart'
      };
      const done = () => {
        if (productJson) {
          try {
            const product = JSON.parse(productJson);
            product.quantity = parentQty;
            app.dl.addedToCart(JSON.stringify(product));
          } catch (e) {}
        }
        (typeof cb === 'function') && cb();
      };
      const add = () => _this.updateView(data, 'add', done);
      if (replaceKey) {
        const updates = {};
        updates[replaceKey] = 0;
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(add).catch(add);
      } else {
        add();
      }
    },

    // Keep each warranty upsell line (nested child, shown as a strip under its parent) at the same
    // quantity as its parent line. The strip's quantity is locked in the UI, so this is the only
    // place it changes. Runs on every init(); no-op when there are no warranty strips.
    syncWarrantyLines: function () {
      const _this = this;
      const strips = document.querySelectorAll('.mt-cart-warranty[data-warranty-for]');
      if (!strips.length) return;
      const esc = (v) => (window.CSS && CSS.escape ? CSS.escape(v) : v);
      const updates = {};
      strips.forEach(strip => {
        const parent = document.querySelector('.mt-cart__item[data-key="' + esc(strip.dataset.warrantyFor) + '"]');
        if (!parent) return; // parent removed → native nesting already dropped the child
        const parentQty = Number(parent.dataset.quantity);
        const childQty = Number(strip.dataset.quantity);
        if (parentQty && parentQty !== childQty) updates[strip.dataset.key] = parentQty;
      });
      if (Object.keys(updates).length > 0) {
        _this.updateView({ updates: updates, sections: (_this.cartType === 'page') ? 'cart-page' : 'mt-mini-cart' }, 'update');
      }
    },

    init: function () {
      const _this = this;
      const processChange = _this.debounce((data, cb = null) => _this.updateView(data, 'update', cb));

      if (_this.el.items === 0) return;

      _this.cartType = _this.el.cartPageContent ? 'page' : 'mini';
      _this.notForSale.variants = [..._this.el.items].filter(i => i.dataset.nfs).map(i => Number(i.dataset.variant));
      _this.notForSale.keysToRemove = [];
      _this.el.items.forEach(item => {
        const itemKey = item.dataset.key;
        const itemVariant = item.dataset.variant;
        const itemBundleId = item.dataset.bundleId;
        const quantityInput = item.querySelector('.mt-quantity__input, [data-cart-qty-input]');
        const removeButton = item.querySelector('.mt-cart-item__remove a, [data-cart-remove]');

        // Not for individual sale
        if (_this.notForSale.variants.includes(Number(itemVariant))) {
          if (!itemBundleId) {
            _this.notForSale.keysToRemove.push(itemKey);
          } else {
            const otherItems = [..._this.el.items].filter(item => item.dataset.bundleId === itemBundleId);
            (otherItems.length === 1) && _this.notForSale.keysToRemove.push(itemKey);
          }
        }

        // Quantity
        if (quantityInput && !quantityInput.getAttribute('data-event')) {
          quantityInput.addEventListener('change', e => {
            e.preventDefault();
            const data = { updates: {} };
            const quantity = (Number(quantityInput.value) > _this.cartLimit) ? _this.cartLimit : Number(quantityInput.value);
            data.sections = (_this.cartType === 'page') ? 'cart-page' : 'mt-mini-cart';
            data.updates[itemKey] = quantity;

            // Keep an associated warranty line in sync within the SAME request (avoids a second re-render)
            const esc = (v) => (window.CSS && CSS.escape ? CSS.escape(v) : v);
            const warrantyStrip = document.querySelector('.mt-cart-warranty[data-warranty-for="' + esc(itemKey) + '"]');
            if (warrantyStrip && warrantyStrip.dataset.key) {
              data.updates[warrantyStrip.dataset.key] = quantity;
            }

            // ATC event
            let cb = null;
            if (quantity > quantityInput.getAttribute('value')) {
              const delta = quantity - Number(quantityInput.getAttribute('value'));
              const productsToReport = [];
              const product = JSON.parse(item.dataset.productJson);
              product.quantity = delta;
              productsToReport.push(JSON.stringify(product));
              if (warrantyStrip && warrantyStrip.dataset.product) {
                try {
                  const warranty = JSON.parse(warrantyStrip.dataset.product);
                  warranty.quantity = delta;
                  productsToReport.push(JSON.stringify(warranty));
                } catch (e) {}
              }
              cb = () => app.dl.addedToCart(...productsToReport);
            }

            processChange(data, cb);
          });
          quantityInput.setAttribute('data-event', 1);
        }

        // Remove
        if (removeButton) {
          removeButton.addEventListener('click', e => {
            e.preventDefault();
            const data = { updates: {} };
            data.sections = (_this.cartType === 'page') ? 'cart-page' : 'mt-mini-cart';
            data.updates[itemKey] = 0;

            if (itemBundleId !== '') {
              if (_this.bundlesAdjust[itemBundleId]) {
                _this.bundlesAdjust[itemBundleId] += 1;
              } else {
                _this.bundlesAdjust[itemBundleId] = 1;
              }
              
              const otherItems = [...document.querySelectorAll(`.mt-cart-item[data-bundle-id="${itemBundleId}"], [data-cart-item][data-bundle-id="${itemBundleId}"]`)].filter(i => i.dataset.key !== itemKey);
              if (otherItems.every(item => item.dataset.editable === 'false' && item.dataset.removable === 'false')) {
                otherItems.forEach(item => (data.updates[item.dataset.key] = 0));
              }
            }

            _this.updateView(data, 'update');
          });
        }
      });

      // Not for individual sale
      if (_this.notForSale.keysToRemove.length > 0) {
        const data = { updates: {} };
        data.sections = (_this.cartType === 'page') ? 'cart-page' : 'mt-mini-cart';
        _this.notForSale.keysToRemove.forEach(key => (data.updates[key] = 0));
        _this.updateView(data, 'update');
      }

      // Mini cart — bind close once (miniCartClose persists across updates; guard avoids
      // re-binding on every init())
      if (_this.el.miniCart && _this.el.miniCartClose && !_this.el.miniCartClose.dataset.event) {
        _this.el.miniCartClose.addEventListener('click', e => {
          e.preventDefault();
          _this.el.miniCart.classList.remove('visible');
          _this.el.miniCart.setAttribute('aria-hidden', true);
          setTimeout(() => _this.el.miniCart.classList.remove('active'), 300);
        });
        _this.el.miniCartClose.dataset.event = '1';
      }

      // Disable submit by Enter
      const enterScope = _this.cartType === 'page' ? _this.el.cartPageContent : _this.el.cartForm;
      if (enterScope && !enterScope.dataset.enterGuard) {
        enterScope.dataset.enterGuard = 'true';
        enterScope.addEventListener('keydown', e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }

      // Warranty upsell strips — bind actions once per strip (guard avoids re-binding on re-render)
      document.querySelectorAll('.mt-cart-warranty').forEach(strip => {
        // "Added" strip: remove the warranty line
        const removeBtn = strip.querySelector('[data-warranty-remove]');
        if (removeBtn && !removeBtn.dataset.event) {
          removeBtn.addEventListener('click', e => {
            e.preventDefault();
            const data = { updates: {}, sections: (_this.cartType === 'page') ? 'cart-page' : 'mt-mini-cart' };
            data.updates[strip.dataset.key] = 0;
            const parentKey = strip.dataset.parentKey;
            _this.updateView(data, 'update', () => {
              // Re-open the upsell for the same line so the shopper can pick a plan again.
              document.dispatchEvent(new CustomEvent('warranty:open', { detail: { parentKey: parentKey } }));
            });
          });
          removeBtn.dataset.event = '1';
        }
        // Promo strip: add the default (pricier) warranty variant directly
        const addBtn = strip.querySelector('[data-warranty-add]');
        if (addBtn && !addBtn.dataset.event) {
          addBtn.addEventListener('click', e => {
            e.preventDefault();
            app.utilities.toggleButtonLoading(addBtn, true);
            _this.addWarranty(strip.dataset.variant, strip.dataset.parentKey, null, strip.dataset.product);
          });
          addBtn.dataset.event = '1';
        }
        // Promo strip: clicking the title opens the modal to pick a (lower) plan for this parent
        const openBtn = strip.querySelector('[data-warranty-open]');
        if (openBtn && !openBtn.dataset.event) {
          openBtn.addEventListener('click', e => {
            e.preventDefault();
            document.dispatchEvent(new CustomEvent('warranty:open', { detail: { parentKey: strip.dataset.parentKey } }));
          });
          openBtn.dataset.event = '1';
        }
      });

      _this.getAllBundles();
      _this.syncWarrantyLines();
    }
  },

  collection: {
    el: {
      section: document.querySelectorAll('.mt-collection'),
      filters: document.querySelectorAll('.mt-collection-filters__list--dynamic'),
      toggleButton: document.querySelectorAll('.mt-collection__view-all'),
      cpOtherSections: document.querySelectorAll('.mt-slim-banner, .mt-membership-offers')
    },
    filterHashes: ['#all'],
    isCollectionPage: (document.querySelector('.template-collection')) ? true : false,

    filters: function () {
      const _this = this;
      if (_this.el.filters.length === 0) return;

      const allCollections = document.querySelectorAll('.mt-collection');
      _this.el.filters.forEach(filterBox => {
        const filters = filterBox.querySelectorAll('a');

        filters.forEach(filter => {
          const collection = document.querySelector(`${filter.hash}.mt-collection`);
          const collectionToggle = collection?.querySelectorAll('.mt-collection__view-all, .mt-collection__action-wrapper');
          const collectionHiddenProducts = collection?.querySelectorAll('.mt-collection__list-item--hidden-default');
          const filterItem = filter.closest('li');

          if (collection || _this.filterHashes.includes(filter.hash)) {
            _this.filterHashes.push(filter.hash);
            filter.addEventListener('click', e => {
              e.preventDefault();

              if (filter.hash === '#all') {
                allCollections.forEach(c => {
                  (c.id === 'sale') ? c.classList.add('hidden') : c.classList.remove('hidden');
                  const cToggle = c.querySelectorAll('.mt-collection__view-all, .mt-collection__action-wrapper');
                  const cHiddenProducts = c.querySelectorAll('.mt-collection__list-item--hidden-default');
                  if (cToggle.length > 0) {
                    cToggle.forEach(ct => ct.classList.remove('hidden'));
                    cHiddenProducts.forEach(product => product.classList.add('hidden'));
                  }
                });
                _this.isCollectionPage && _this.el.cpOtherSections.forEach(section => section.classList.remove('hidden'));
              } else {
                allCollections.forEach(c => c.classList.add('hidden'));
                collection.classList.remove('hidden');

                if (collectionToggle.length > 0) {
                  collectionToggle.forEach(ct => ct.classList.add('hidden'));
                  collectionHiddenProducts.forEach(product => product.classList.remove('hidden'));
                }
                if (_this.isCollectionPage) {
                  _this.el.cpOtherSections.forEach(section => section.classList.add('hidden'));
                }
              }
              filters.forEach(f => f.classList.remove('active'));
              filter.classList.add('active');
              filterItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

              // Update URL
              let currentUrl = window.top.location.href.split('#')[0];
              (filter.hash !== '#all') && (currentUrl += filter.hash);
              window.history.replaceState(null, document.title, currentUrl);
            });
          } else {
            filterItem.remove();
          }
        });
      });

      if (window.location.hash && _this.el.filters.length > 0) {
        const filterHash = window.location.hash.split('?')[0];
        if (_this.filterHashes.includes(filterHash)) {
          const filter = _this.el.filters[0].querySelector(`a[href="${filterHash}"]`);
          filter.dispatchEvent(new Event('click'));
        }
      }
    },

    init: function () {
      const _this = this;
      if (_this.el.section.length === 0) return;

      // Additional events
      _this.el.toggleButton.forEach(button => {
        const t = { all: button.dataset.tAll, less: button.dataset.tLess };
        const collection = button.closest('.mt-collection');
        const allToggleButtons = collection.querySelectorAll('.mt-collection__view-all');
        const allProducts = collection.querySelectorAll('.mt-collection__list-item');
      
        button.addEventListener('click', e => {
          e.preventDefault();
          button.classList.toggle('active');
          const isActive = button.classList.contains('active');
          allProducts.forEach(product => {
            const shouldBeHidden = !isActive && product.classList.contains('mt-collection__list-item--hidden-default');
            product.classList.toggle('hidden', shouldBeHidden);
          });
          allToggleButtons.forEach(b => { b.querySelector('span:first-child').innerHTML = isActive ? t.less : t.all; });
        });
      });      

      // Filters
      _this.filters();
    }
  },

  footer: {
    breakpoint: (window.innerWidth >= 992) ? 'desktop' : 'mobile',
    el: {
      menuHeaders: document.querySelectorAll('.mt-footer-nav__title'),
      accessibility: document.querySelectorAll('a[href*="#accessibility"]'),
      menus: document.querySelectorAll('.mt-footer-v2__menu')
    },

    initV2: function() {
      const _this = this;
      const toggleAllMenus = (action = 'show') => {
        _this.el.menus.forEach(menu => {
          const list = menu.querySelector('.mt-footer-v2__menu-list');

          if (action === 'show') {
            menu.open = true;
            menu.classList.add('is-active');
            list.setAttribute('aria-hidden', false);
          } else {
            menu.open = false;
            menu.classList.remove('is-active');
            list.setAttribute('aria-hidden', true);
          }
        });
      };

      _this.el.menus.forEach(menu => {
        const list = menu.querySelector('.mt-footer-v2__menu-list');
        
        menu.addEventListener('toggle', e => {
          e.preventDefault();
          if (_this.breakpoint === 'desktop') return;

          menu.classList.toggle('is-active', menu.open);
          list.setAttribute('aria-hidden', !menu.open);

          // Close other
          menu.open && _this.el.menus.forEach(m => {
            if (m === menu) return;

            m.open = false;
            m.classList.remove('is-active');
            m.querySelector('.mt-footer-v2__menu-list').setAttribute('aria-hidden', true);
          });
        });

        // Hide by default on mobile
        (window.innerWidth < 992) && toggleAllMenus('hide');
      });

      window.addEventListener('resize', () => {
        const newBreakpoint = (window.innerWidth >= 992) ? 'desktop' : 'mobile';
        if (newBreakpoint === _this.breakpoint) return;

        (newBreakpoint === 'desktop') ? toggleAllMenus('show') : toggleAllMenus('hide');
        _this.breakpoint = newBreakpoint;
      });
    },

    init: function () {
      const _this = this;
      if (_this.el.menuHeaders.length === 0 && _this.el.accessibility.length === 0) return;
      _this.el.menuHeaders.forEach(header => {
        const menu = header.closest('.mt-footer-nav');
        const list = menu.querySelector('.mt-footer-nav__list');
        header.addEventListener('click', e => {
          e.preventDefault();

          _this.el.menuHeaders.forEach(otherHeader => {
            if (header !== otherHeader) {
              const otherMenu = otherHeader.closest('.mt-footer-nav');
              const otherList = otherMenu.querySelector('.mt-footer-nav__list');
              otherMenu.classList.remove('active');
              otherList.setAttribute('aria-hidden', true);
            }
          });
          menu.classList.toggle('active');
          list.setAttribute('aria-hidden', !menu.classList.contains('active'));
        });
      });
      _this.el.accessibility.forEach(link => {
        link.addEventListener('click', e => e.preventDefault());
      });
      window.addEventListener('resize', () => {
        if (window.innerWidth < 768) return;

        const footerNavLists = document.querySelectorAll('.mt-footer-nav__list');
        footerNavLists.forEach(list => {
          list.setAttribute('aria-hidden', false);
        });
      });
    }
  },

  discounts: {
    membershipIds: [40703995805741, 40704022741037, 40387475243052, 40387475308588],
    membershipDiscountCode: 'DS-MEMB20AS90T',
    membershipDiscountEnabled: false,

    autoCodeStorageKey: 'bp-auto-discount',

    init: function () {
      const urlParams = new URLSearchParams(window.location.search);
      const discount = urlParams.get('discount');
      if (discount !== null) {
        try {
          window.sessionStorage.setItem(this.autoCodeStorageKey, (window.autoDiscountCode || '').trim());
        } catch (e) {}
        this.apply(discount);
        return;
      }
      this.applyAutoCode();
    },

    applyAutoCode: function () {
      const code = (window.autoDiscountCode || '').trim();
      const onCartPage = !!document.querySelector('.cart__grid');
      if (!code) return;
      try {
        if (!onCartPage && window.sessionStorage.getItem(this.autoCodeStorageKey) === code) return;
      } catch (e) {
        return;
      }

      const skipIfActive = onCartPage || window.autoDiscountMode === 'no_other_code';
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => (response.ok ? response.json() : null))
        .then(cart => {
          if (!cart || (skipIfActive && (cart.discount_codes || []).some(d => d.applicable))) return;
          this.apply(code, updated => {
            if (this.isApplied(updated, code)) {
              try {
                window.sessionStorage.setItem(this.autoCodeStorageKey, code);
              } catch (e) {}
            }
            onCartPage && window.app.cart.updateView({ updates: {}, sections: 'cart-page' }, 'update');
          });
        })
        .catch(() => {});
    },

    hasMembership: function (items) {
      if (!this.membershipDiscountEnabled) return false;
      if (!items || !Array.isArray(items)) return false;
      return items.some(item => this.membershipIds.includes(Number(item.id)));
    },

    skipAutoCode: function (removedCode) {
      const code = (window.autoDiscountCode || '').trim();
      const autoCodes = code.split(',').map(c => c.trim().toUpperCase());
      if (!code || !autoCodes.includes(String(removedCode).trim().toUpperCase())) return;
      try {
        window.sessionStorage.setItem(this.autoCodeStorageKey, code);
      } catch (e) {}
    },

    isApplied: function (cart, code) {
      const applied = ((cart && cart.discount_codes) || []).filter(d => d.applicable).map(d => d.code.toUpperCase());
      return String(code).split(',').map(c => c.trim().toUpperCase()).filter(Boolean).every(c => applied.includes(c));
    },

    apply: function (code, callback = null) {
      if (!code) {
        (typeof callback === 'function') && callback(null);
        return;
      }
      const done = (cart = null) => (typeof callback === 'function') && callback(cart);
      const root = window.Shopify.routes.root;
      fetch(root + 'cart.js')
        .then(response => (response.ok ? response.json() : null))
        .then(cart => {
          const codes = ((cart && cart.discount_codes) || []).map(d => d.code);
          const known = codes.map(c => c.toUpperCase());
          const added = String(code).split(',').map(c => c.trim()).filter(c => c && !known.includes(c.toUpperCase()));
          if (!added.length) return cart;
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: [...codes, ...added].join(',') })
          }).then(response => (response.ok ? response.json() : null));
        })
        .then(done)
        .catch(() => done());
    },

    withMembership: function (items, fn) {
      if (this.hasMembership(items)) {
        this.apply(this.membershipDiscountCode, fn);
      } else {
        fn();
      }
    }
  },

  utilities: {
    setCookie: (name, value, days) => {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    },
    
    getCookie: name => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },

    removeCookie: name => {
      document.cookie = name + '=; Max-Age=-99999999;';
    },

    preloadImages: (...args) => {
      const images = [];
      for (var i = 0; i < args.length; i++) {
        images[i] = new Image();
        images[i].src = args[i];
      }
    },

    validateMarketCatalog: async () => {
      const isEUHost = window.location.host === 'blazepod.eu';
      const urlParams = new URLSearchParams(window.location.search);
      const isAffiliate = urlParams.get('utm_medium') === 'affiliate';
      const ukPath = '/en-uk';
      if (!isEUHost || !isAffiliate) return;

      const redirectToUK = () => {
        const { pathname, search, origin } = window.location;
        window.location.href = `${origin}${ukPath}${pathname}${search}`;
      };

      let userCountry = window.sessionStorage.getItem('bpUserCountry') || '';

      if (!userCountry) {
        try {
          const response = await fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`);
          const data = await response.json();
          userCountry = data?.detected_values?.country?.handle || '';
          window.sessionStorage.setItem('bpUserCountry', userCountry);
        } catch (error) {
          console.error('Error fetching user country:', error);
          return;
        }
      }

      if (userCountry === 'GB' && !window.location.pathname.includes(ukPath)) {
        redirectToUK();
      }
    },

    // Short random id used for grouping cart line items (bundles, unique items, etc.)
    generateShortId: () => Math.random().toString(36).slice(2, 7),

    // Toggle the loading/disabled state of a CTA button
    toggleButtonLoading: (button, isLoading) => {
      if (!button) return;
      button.disabled = isLoading;
      button.classList.toggle('mt-btn--loading', isLoading);
    },

    // Return the cartConnections groups a given product belongs to (empty array when none)
    getCartConnectionsFor: (productId) => {
      const connections = window.app.cartConnections;
      if (!connections || connections.length === 0) return [];
      return connections.filter(group => group.products_id_list.includes(Number(productId)));
    }
  },

  video: {
    els: document.querySelectorAll('.mt-video'),

    init: function () {
      const _this = this;
      if (_this.els.length === 0) return;

      _this.els.forEach(videoBlock => {
        const overlay = videoBlock.querySelector('.mt-video__overlay');
        const video = videoBlock.querySelector('video');

        overlay && overlay.addEventListener('click', e => {
          e.preventDefault();
          video && video.play();
        });

        video.addEventListener('play', () => {
          videoBlock.classList.add('mt-video--playing');
          video.controls = true;
        });

        video.addEventListener('pause', () => {
          videoBlock.classList.remove('mt-video--playing');
          video.controls = false;
        });

        videoBlock.classList.remove('mt-video--loading');
      });
    }
  },

  newsletter: {
    el: {
      footerForm: document.querySelector('.mt-footer-newsletter'),
      footerHeader: document.querySelector('.mt-footer-newsletter__header'),
      footerDescription: document.querySelector('.mt-footer-newsletter__description'),
      footerFields: document.querySelector('.mt-footer-newsletter__fields'),
      footerInput: document.querySelector('.mt-footer-newsletter input[name="contact[email]"]'),
      footerBtn: document.querySelector('.mt-footer-newsletter .mt-btn'),
      footerSuccess: document.querySelector('.mt-footer-newsletter__message--success'),
      footerError: document.querySelector('.mt-footer-newsletter__message--error')
    },

    showError: function (message = '') {
      const _this = this;

      _this.el.footerFields.classList.add('is-error');
      _this.el.footerError.innerHTML = (message !== '') ? message : _this.el.footerError.dataset.default;
      _this.el.footerError.classList.remove('hidden');
      _this.el.footerSuccess.classList.add('hidden');
    },

    showSuccess: function (email = '') {
      const _this = this;
     
      _this.el.footerHeader.innerHTML = _this.el.footerSuccess.dataset.header;
      _this.el.footerSuccess.innerHTML = _this.el.footerSuccess.innerHTML.replace('{email}', `<span>${email}</span>`);
      _this.el.footerForm.classList.add('mt-footer-newsletter--success');
    },
    
    validateEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    init: function () {
      const _this = this;

      // Footer
      if (_this.el.footerForm && _this.el.footerBtn) {
        _this.el.footerForm.addEventListener('keydown', e => {
          if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            _this.el.footerBtn.dispatchEvent(new Event('click'));
          }
        });
        _this.el.footerBtn.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();

          const form = _this.el.footerForm;
          const email = form.querySelector('input[name="contact[email]"]');
          if (!email || email.value === '' || !_this.validateEmail(email.value)) {
            _this.showError('Enter a valid email address');
            return;
          }
          
          fetch(form.action, {
            method: form.method,
            body: new FormData(form)
          })
            .then(response => {
              if (response.url.includes('customer_posted=true')) {
                _this.showSuccess(email.value);
                app.dl.emailSignUp(email.value, 'footer');
              } else {
                _this.showError();
              }
            })
            .catch(() => {
              _this.showError();
            });
        });
      }

      // Klaviyo forms
      window.addEventListener('klaviyoForms', function(e) {
        if (e.detail.type == 'submit') {
          app.dl.emailSignUp(e.detail.metaData.$email, 'popup');
        }
      });
    }
  },

  textImage: {
    els: document.querySelectorAll('.mt-text-image'),

    init: function() {
      const _this = this;
      if (_this.els.length === 0) return;

      _this.els.forEach(el => {
        // General
        let header = el.querySelector('.mt-text-image__header');
        if (!header && el.classList.contains('mt-text-image--lets-talk')) {
          header = el.querySelector('.mt-text-image__description');
        }
        
        // Videos
        const video = el.querySelector('.mt-text-image__video');
        const videoButton = el.querySelector('.mt-text-image__video-btn');
        if (video && videoButton) {
          videoButton.addEventListener('click', e => {
            e.preventDefault();
            video.muted = !video.muted;
            video.controls = !video.controls;
            video.play();
            videoButton.classList.add('hidden');

            // Additional DL events
            if (el.id === 'reactive-intelligence') {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'video_play',
                video_name: window.app.dl.sanitize(header?.innerText)
              });
            }
          });
        }

        // Additional DL events
        const link = el.querySelector('.mt-text-image__action .mt-btn');
        if (link && header) {
          link.addEventListener('click', () => app.dl.ctaClick(link.innerText, { location: header.innerText }));
        } 
      });
    }
  },

  featuredProduct: {
    els: document.querySelectorAll('.mt-featured-product'),

    init: function() {
      const _this = this;
      if (_this.els.length === 0) return;

      _this.els.forEach(el => {
        // Additional DL events
        const title = el.querySelector('.mt-featured-product__header');
        const link = el.querySelector('.mt-featured-product__action .mt-btn');
        if (title && link) {
          link.addEventListener('click', () => app.dl.ctaClick(link.innerText, { location: title.innerText }));
        }
      });
    }
  },

  lightbox: {
    el: {
      triggers: document.querySelectorAll('[data-lity]'),
      modal: document.querySelector('.mt-modal--lightbox'),
      modalContent: document.querySelector('.mt-modal--lightbox .mt-modal__content')
    },

    getYtVideoId: function (url = null) {
      if (url === null) return;
      const urlObj = new URL(url);
      if (urlObj.host === 'youtu.be') {
        return urlObj.pathname.replace('/', '');
      } else {
        return urlObj.searchParams.get('v');
      }
    },
  
    init: function () {
      const _this = this;
      _this.el.triggers = document.querySelectorAll('[data-lity]');
  
      if (_this.el.triggers.length === 0) return;
  
      _this.el.triggers.forEach(trigger => {
        if (trigger.dataset.lity === 'true') return;
  
        const targetUrl = trigger.href || trigger.dataset.href || '';
        let targetType = targetUrl.includes('.mp4') ? 'video' : 'unknown';
        if (targetUrl.includes('youtube.com') || targetUrl.includes('youtu.be')) {
          targetType = 'youtube';
        }
  
        if (targetType === 'video') {
          const videoTag = document.createElement('video');
          videoTag.src = targetUrl;
          videoTag.volume = 0.2;
          videoTag.setAttribute('playsinline', '');
          videoTag.setAttribute('controls', '');
          videoTag.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback noplaybackrate');
          let videoRatio = null;
  
          trigger.addEventListener('mouseenter', () => {
            videoTag.load();
            videoTag.addEventListener('loadedmetadata', () => {
              videoRatio = `${videoTag.videoWidth} / ${videoTag.videoHeight}`;
            });
          }, { once: true });
  
          trigger.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            if (e.target.classList.contains('mt-activity-banner__close') || e.target.closest('.mt-activity-banner__close')) return;
  
            _this.open({ type: 'video', content: videoTag, videoRatio });
          });
        }
  
        if (targetType === 'youtube') {
          const videoId = _this.getYtVideoId(targetUrl);
  
          trigger.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
  
            _this.open({ type: 'youtube', content: videoId });
          });
        }
  
        trigger.dataset.lity = 'true';
      });
    },
  
    open: function ({ type, content, videoRatio = null }) {
      const _this = this;
  
      _this.el.modalContent.innerHTML = '';
  
      if (type === 'video') {
        const videoTag = content;
  
        if (videoRatio !== null) {
          _this.el.modalContent.style.setProperty('--video-ratio', videoRatio);
        } else {
          videoTag.load();
          videoTag.addEventListener('loadedmetadata', () => {
            const ratio = `${videoTag.videoWidth} / ${videoTag.videoHeight}`;
            _this.el.modalContent.style.setProperty('--video-ratio', ratio);
          });
        }
  
        _this.el.modalContent.appendChild(videoTag);
        app.modal.open(_this.el.modal);
        videoTag.play();
      }
  
      if (type === 'youtube') {
        const playerWrapper = document.createElement('div');
        playerWrapper.classList = 'video-wrapper';
  
        const player = document.createElement('div');
        player.id = 'yt-lightbox';
  
        playerWrapper.appendChild(player);
        _this.el.modalContent.appendChild(playerWrapper);
  
        const ytPlayer = new YT.Player(player, {
          height: '360',
          width: '640',
          host: 'https://www.youtube-nocookie.com',
          videoId: content,
          playerVars: { 
            autoplay: 1, 
            rel: 0,
            origin: window.location.host
          }
        });
  
        document.addEventListener('mt-lightbox-closed', () => {
          ytPlayer && ytPlayer.stopVideo();
        }, { once: true });
  
        app.modal.open(_this.el.modal);
      }
    }
  },

  klaviyo: {
    _learnq: window._learnq || [],
    klAjax: true,

    init: function () {
      const _this = this;
      
      // Popups
      const popups = {
        '#kl-popup': ['UVgcEC', 'UVgcEC'],
        '#kl-sms-popup': ['UeUTPi', 'UeUTPi'],
        '#kl-popup-uk': ['UeUTPi', 'UeUTPi'],
        '#kl-sn-popup': ['UeUTPi', 'UeUTPi'],
        '#kl-ds-popup': ['UVgcEC', 'UVgcEC'],
        '#kl-ds-sms-popup': ['UeUTPi', 'UeUTPi'],
        '#kl-ds-popup-uk': ['UeUTPi', 'UeUTPi'],
        '#kl-ds-sn-popup': ['UeUTPi','UeUTPi']
      };
      Object.entries(popups).forEach(entry => {
        const [trigger, modalId] = entry;
        const links = document.querySelectorAll(`[href="${trigger}"]`);
        links.forEach(link => {
          link.addEventListener('click', e => {
            e.preventDefault();
            const [desktopId, mobileId] = modalId;
            const formId = (window.innerWidth >= 768) ? desktopId : mobileId;
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', formId]);
          });
        });
      });

      // Newsletter signup
      const footerForm = document.querySelector('#footer-newsletter');
      const formEmail = footerForm?.querySelector('input[name="contact[email]"]');
      if (footerForm && formEmail) {
        footerForm.addEventListener('submit', () => {
          _this._learnq.push(['identify', { '$email' : formEmail.value }]);
        });
      }
    }
  },

  gorgias: {
    init: function () {
      document.addEventListener('click', e => {
        const link = e.target.closest('[href="#chat"]');
        if (!link) return;
        e.preventDefault();
        window.GorgiasChat && window.GorgiasChat.open();
      });
    }
  },

  vwo: {
    data: {
      tcb: 'control' 
    },

    event: (name = '', data = {}) => {
      if (name === '') return;

      window.VWO = window.VWO || [];
	    VWO.event = VWO.event || function () {VWO.push(["event"].concat([].slice.call(arguments)))};
      VWO.event(name, data);
    },

    testCollectionByok: function() {
      const _this = this;
      const removeSlide = (id = null) => {
        const section = document.querySelector('.mt-featured-collection');
        const sliders = document.querySelectorAll('.mt-featured-collection__list .swiper:not(.vwo-updated)');

        if (!section || id === null) return;
        sliders.forEach(function(slider) {
          const list = slider.closest('.mt-featured-collection__list');
          const slides = slider.querySelectorAll('.swiper-slide');
          let slidesCount = list.dataset.slides;
          if (slides[id]) slides[id].remove();
          list.dataset.slides = Number(slidesCount) - 1;
          slider.classList.add('vwo-updated');
          window.app.featuredCollection.init();
        });
      };
      let tcbUpdated = false;

      // Observer
      const tcbEl = document.querySelector(".mt-featured-collection");
      const tcbObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (entry.target.classList.contains('mt-featured-collection') && tcbUpdated == false) {
              (_this.data.tcb === 'control') ? removeSlide(1) : removeSlide(2);
              tcbUpdated = true;
              tcbObserver.unobserve(entry.target);
            }
          }
        });
      }, { threshold: 0 });
      tcbEl && tcbObserver.observe(tcbEl);
    },

    init: function() {
      //this.testCollectionByok();
    }
  },

  dl: {
    eventElements: document.querySelectorAll('.mt-slim-banner__button, .text-on-media .mt-btn, .persona-card, .mt-collection-card a, .mt-category a, .category-nav__item'),
    mainCategories: ['Bundles', 'Kits', 'Accessories', 'Reactive Intelligence Wall™'],

    sanitize(val) {
      if (typeof val === 'string') return val.replace(/\s+/g, ' ').trim();
      if (val && typeof val === 'object' && !Array.isArray(val)) {
        return Object.fromEntries(Object.entries(val).map(([k, v]) => [k, this.sanitize(v)]));
      }
      return val;
    },

    addedToCart(...productsJson) {
      if (productsJson.length === 0) return;

      const _this = this;
      const productsData = [];

      productsJson.forEach(json => {
        if (!json) return;
        const product = JSON.parse(json);
        const matchedCategories = _this.mainCategories.filter(category => product.categories.includes(category));
        const category = (matchedCategories.length > 0) ? matchedCategories[0] : 'All';
        
        const productData = {
          id: product.sku,
          name: product.title,
          brand: product.vendor,
          category: category,
          variant: product.variant,
          price: String(product.price),
          quantity: String(product.quantity),
          product_id: String(product.id),
          variant_id: String(product.variant_id)
        };

        if (product.upsell) {
          productData.upsell = 'pdp_addon';
        }

        productsData.push(productData);
      });

      if (productsData.length === 0) return;

      const collection = productsData[0] ? JSON.parse(productsJson[0])?.collection : '';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'cm_add_to_cart',
        feedLabel: window.Shopify.feedLabel,
        ...(collection && { collection_name: this.sanitize(collection) }),
        ecommerce: {
          currencyCode: window.Shopify.currency.active,
          add: {
            products: productsData
          }
        }
      });
    },

    blogStickyBannerClick(text = '') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'blog_sticky_banner_click',
        link_text: this.sanitize(text)
      });
    },

    blogRelatedArticleClick(text = '') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'blog_related_post_click',
        link_text: this.sanitize(text)
      });
    },

    blogRelatedProductClick(text = '') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'blog_related_product_click',
        link_text: this.sanitize(text)
      });
    },

    emailSignUp(email = null, location = null) {
      if (email === null || location === null) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'email_signup',
        email: this.sanitize(email),
        location: this.sanitize(location)
      });
    },
    
    menuClick(page = null, params = {}) {
      if (page === null) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'menu_click',
        link_text: this.sanitize(page),
        ...this.sanitize(params)
      });
    },

    menuHover(page = null, params = {}) {
      if (page === null) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'menu_hover',
        link_id: this.sanitize(page),
        ...this.sanitize(params)
      });
    },

    menuOpen(params = {}) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'menu_open',
        ...this.sanitize(params)
      });
    },

    click(text = '', params = {}) {
      const eventData = { event: 'click', ...this.sanitize(params) };
      (text !== '') && (eventData.link_text = this.sanitize(text));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
    },

    customClick(text = '', params = {}) {
      const eventData = { event: 'custom_click', ...this.sanitize(params) };
      (text !== '') && (eventData.link_text = this.sanitize(text));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
    },

    ctaClick(text = '', params = {}) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'cta_click',
        link_text: this.sanitize(text),
        ...this.sanitize(params)
      });
    },

    contentCardClick(page = null) {
      if (page === null) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'content_card_click',
        link_text: this.sanitize(page)
      });
    },

    tileInteraction(text = null) {
      if (text === null) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'tile_interaction',
        link_text: this.sanitize(text)
      });
    },

    selectItem(productJson = null, list_name = '') {
      if (productJson === null) return;

      const _this = this;
      const product = JSON.parse(productJson);
      const matchedCategories = _this.mainCategories.filter(category => product.categories.includes(category));
      const category = (matchedCategories.length > 0) ? matchedCategories[0] : 'All';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'select_item',
        ...(product.collection && { collection_name: this.sanitize(product.collection) }),
        ecommerce: {
          items: [{
            item_name: product.title,
            item_product_id: String(product.id),
            item_variant_id: String(product.variant_id),
            item_id: product.sku,
            item_brand: product.vendor,
            item_category: category,
            item_variant: product.variant,
            item_list_name: list_name,
            quantity: '1'
          }]
        }
      });
    },

    viewItem(productJson = null) {
      if (productJson === null) return;
      
      const _this = this;
      const product = JSON.parse(productJson);
      const matchedCategories = _this.mainCategories.filter(category => product.categories.includes(category));
      const category = (matchedCategories.length > 0) ? matchedCategories[0] : 'All';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "dl_view_item",
        feedLabel: window.Shopify.feedLabel,
        ecommerce: {
          currencyCode: window.Shopify.currency.active,
          detail: {
            products: [
              {
                id: product.sku,
                name: product.title,
                brand: product.vendor,
                category: category,
                variant: product.variant,
                price: String(product.price),
                quantity: String(product.quantity),
                product_id: String(product.id),
                variant_id: String(product.variant_id)
              }
            ]
          }
        }
      });
    },

    init: function() {
      const _this = this;
      const collectionName = _this.sanitize(document.querySelector('.mt-collection-header')?.dataset.collection || '');
      _this.eventElements.forEach(el => {
        if (el.closest('.mt-slim-banner')) {
          const section = el.closest('.mt-slim-banner')?.querySelector('.mt-slim-banner__header');
          const locationText = section ? section.innerText : 'Build Your Own Kit Banner';
          el.addEventListener('click', () => _this.ctaClick(el.innerText, { location: locationText, ...(collectionName && { collection_name: collectionName }) }));
        }
        if (el.closest('.text-on-media')) {
          const section = el.closest('.text-on-media')?.querySelector('.text-on-media__header');
          const locationText = section ? section.dataset.text : '';
          el.addEventListener('click', () => _this.ctaClick(el.dataset.text, { location: locationText }));
        }
        if (el.classList.contains('persona-card')) {
          const label = el.querySelector('.persona-card__label');
          label && el.addEventListener('click', () => _this.ctaClick(label.dataset.text, { location: '' }));
        }
        if (el.closest('.mt-category')) {
          const card = el.closest('.mt-category');
          const locationText = card.closest('.mt-collection')?.querySelector('.mt-collection__heading')?.innerText || '';
          const linkText = card.querySelector('.mt-category__title')?.innerText || '';
          el.addEventListener('click', () => _this.customClick(linkText, { location: locationText, ...(collectionName && { collection_name: collectionName }) }));
        }
        if (el.closest('.mt-collection-card')) {
          const card = el.closest('.mt-collection-card');
          const locationText = card.querySelector('.mt-collection-card__title')?.innerText || '';
          const linkText = el.querySelector('.mt-btn__inner')?.innerText || el.innerText;
          el.addEventListener('click', () => {

            _this.ctaClick(linkText, { location: locationText, ...(collectionName && { collection_name: collectionName }) });
          });
        }
        if (el.closest('.category-nav')) {
          const label = el.querySelector('.category-nav__label');
          el.addEventListener('click', () => _this.ctaClick(
            label?.innerText || '',
            { location: 'Category nav', ...(collectionName && { collection_name: collectionName }) }
          ));
        }
      });
    }
  },

  init: function () {
    this.footer.init();
    this.footer.initV2();
    this.form.init();
    this.productForm.init();
    this.productItem.init();
    this.cart.init();
    this.collection.init();
    this.animation.init();
    this.textImage.init();
    this.featuredProduct.init();
    this.lightbox.init();
    this.utilities.validateMarketCatalog();
    this.discounts.init();
    this.video.init();
    this.newsletter.init();
    this.dl.init();
    this.prefetch.init();
    this.klaviyo.init();
    this.gorgias.init();
    this.vwo.init();
  }
};
window.app = app;
window.addEventListener('DOMContentLoaded', () => app.init());
document.addEventListener('mt-reinit-lity', () => app.lightbox.init());

// Youtube API Support
const ytLityElements = document.querySelectorAll('[data-lity][href*="youtube"], [data-lity][href*="youtu.be"], .yt-player');
if (ytLityElements.length > 0) {
  const tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}
window.ytApiLoaded = false;
function onYouTubeIframeAPIReady() {
  window.ytApiLoaded = true;
  document.dispatchEvent(new CustomEvent('yt-api-loaded', {}));
}